import {axios} from '../../services/axios';

export default function getACSRegions({scope}) {
    return axios.get(
        `/ServiceProfiles/ACSDirectRouting/${scope}/Regions/Available`,
    );
}
